/**
 * `changes` reducer - the dated DOE events for `/changes` (BL-0129).
 *
 * One request, one site, no path to guard: a plain request slice. `data` is
 * kept on `_PENDING` for the same stale-while-revalidate reason the
 * familyTimeline slice gives. Registered through `config.addonReducers`.
 */
import { GET_CHANGES } from '../actions/changes';

const initialState = { error: null, data: null, loaded: false, loading: false };

export default function changes(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_CHANGES}_PENDING`:
      return { ...state, error: null, loading: true, loaded: false };
    case `${GET_CHANGES}_SUCCESS`:
      return {
        ...state,
        error: null,
        loading: false,
        loaded: true,
        data: action.result ?? null,
      };
    case `${GET_CHANGES}_FAIL`:
      return { ...state, error: action.error, loading: false, loaded: false };
    default:
      return state;
  }
}
